import { render, staticRenderFns } from "./ListPrice.vue?vue&type=template&id=55146c2a&scoped=true"
import script from "./ListPrice.vue?vue&type=script&lang=js"
export * from "./ListPrice.vue?vue&type=script&lang=js"
import style0 from "./ListPrice.vue?vue&type=style&index=0&id=55146c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55146c2a",
  null
  
)

export default component.exports